'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components2 = require('components');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _pacomo = require('utils/pacomo');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RequirementNav = function RequirementNav(props) {
    var passengerId = props.passengerId,
        reqSetCode = props.reqSetCode,
        requirementSets = props.requirementSets;


    var reqSetCodes = requirementSets.map(function (obj) {
        return obj.code;
    });

    var i = reqSetCodes.indexOf(reqSetCode);

    var nextReqSet = void 0;
    var prevReqSet = void 0;

    if (i >= 0 && i <= reqSetCodes.length - 1) {
        nextReqSet = typeof reqSetCodes[i + 1] != "undefined" ? reqSetCodes[i + 1] : reqSetCodes[0];
        prevReqSet = i === 0 ? reqSetCodes[reqSetCodes.length - 1] : reqSetCodes[i - 1];
    }

    var nextUrl = '/' + passengerId + '/' + nextReqSet;
    var prevUrl = '/' + passengerId + '/' + prevReqSet;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'span',
            { className: 'prev' },
            _react2.default.createElement(
                _reactRouter.Link,
                { to: prevUrl },
                _react2.default.createElement(_components2.IconLeft, null),
                ' ',
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'requirementNav.prev', defaultMessage: 'Prev' })
            )
        ),
        _react2.default.createElement(
            'span',
            { className: 'next' },
            _react2.default.createElement(
                _reactRouter.Link,
                { to: nextUrl },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'requirementNav.next', defaultMessage: 'Next' }),
                ' ',
                _react2.default.createElement(_components2.IconRight, null)
            )
        )
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(RequirementNav);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/RequirementNav.js
// module id = 1317
// module chunks = 0